
import React from 'react';

const HelpButton = ({ isMobile, toggleContactInfo }) => {
  if (isMobile) {
    return (
      <button
        className="flex items-center justify-center w-10 h-10 rounded-full"
        onClick={toggleContactInfo}
        style={{
          background: 'var(--White, #FFFFFF)',
          border: '1px solid var(--White, #dadadd)',
          boxShadow: '0px 2px 6px 0px #00000014',
          transition: 'box-shadow 0.3s',
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 99999
        }}
      >
        <img
          src="https://img.icons8.com/material-outlined/24/0000FF/email-open.png"
          alt="help icon"
          className="w-5 h-5 object-contain"
        />
      </button>
    );
  }
  
  return (
    <button
      className="flex items-center gap-2 px-3 py-1.5 rounded-full"
      onClick={toggleContactInfo}
      style={{
        background: 'var(--White, #FFFFFF)',
        border: '1px solid var(--White, #dadadd)',
        boxShadow: '0px 2px 6px 0px #00000014',
        transition: 'box-shadow 0.3s',
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: isMobile ? 99999 : 102
      }}
    >
      <span style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '22px',
        letterSpacing: '-0.2px',
        textAlign: 'center',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'clip',
        color: '#000000'
      }}>
        Help & support
      </span>
      <img
        src="https://img.icons8.com/?size=100&id=8GKNsu0eFMQw&format=png&color=000000"
        alt="help icon"
        className="w-5 h-5 object-contain"
      />
    </button>
  );
};

export default HelpButton;